import React, { Component } from "react";
import { Tooltip } from "react-tippy";
import moment from "moment";

import Registry from "../../../Utils/Registry";
import Helpers from "../../../Utils/Helpers";

const months_label = [
    'Jan',
    'Fev',
    'Mar',
    'Avr',
    'Mai',
    'Juin',
    'Juil',
    'Aout',
    'Sept',
    'Oct',
    'Nov',
    'Dec'
];

const UNIT_LABELS = {
    "L": "litres",
    "Kg": "kilogrammes"
}


export default class Heatmap extends Component{
    constructor(props){
        super(props);

        this.nb_days = 366;
        this.nb_days_week = 7;

        this.api = Registry.registered("api");

        this.state = {
            filter: null,
            raw: [],
            data: [],
            max: 0,
            vehicles: [],
            year: moment().format("YYYY"),
            full_quantity: {},
            vehicleMax: undefined
        };
    }

    loadData = () => {
        this.api.get("/stats/fleet/consumption?year=" + this.state.year)
            .then(this.formatData);
    }

    formatData = rawData => {
        const { filter } = this.state;
        let max = 0;
        let viMax = -1;
        let data = {};
        let vehiclesPlate = [];
        let vehicles = [];
        let full_qty = {};

        for(let d of rawData){
            if(!data[d.day]){
                data[d.day] = {
                    qty: 0,
                    items: [],
                    date: d.date
                };
            }
            if(!filter || filter === d.plate){
                data[d.day].qty += d.quantity_delivered;
                data[d.day].items.push({
                    desc: d.description,
                    plate: d.plate,
                    qty: d.quantity_delivered,
                    gas: d.gas_name,
                    unit: d.gas_unit,
                    color: d.color
                });
            }

            if(data[d.day].qty > max)
                max = data[d.day].qty;

            if(full_qty[d.gas_unit] === undefined)
                full_qty[d.gas_unit] = 0;
            full_qty[d.gas_unit] += d.quantity_delivered;

            let vi = vehiclesPlate.indexOf(d.plate);
            if(vi === -1){
                vehicles.push({
                    desc: d.description,
                    plate: d.plate,
                    qty: d.quantity_delivered,
                    unit: d.gas_unit,
                    nb: 1
                });
                vehiclesPlate.push(d.plate);
                vi = vehiclesPlate.length - 1;
            }
            else{
                vehicles[vi].qty += d.quantity_delivered;
                vehicles[vi].nb++;
            }

            if(viMax === -1 || vehicles[vi].qty > vehicles[viMax].qty)
                viMax = vi;
        }

        this.setState({
            full_quantity: full_qty,
            data: data,
            raw: rawData,
            vehicleMax: vehicles[viMax],
            max: max,
            vehicles: vehicles
        });
    };

    componentDidMount(){
        this.loadData();
    }

    getRandomInt(max) {
        return Math.floor(Math.random() * Math.floor(max));
    }

    getToolTip = data => {
        let volByUnit = {};
        return <div>
            <h2 className="heatmap-day-title">{ Helpers.formatDate(data.date, "DD/MM/YYYY") }</h2>
            <ul className="heatmap-day-recap">{
                data.items.map((item, i) => { 
                    if(volByUnit[item.unit] === undefined)
                        volByUnit[item.unit] = 0;
                    volByUnit[item.unit] += item.qty;
                    return <li key={`tooltip-key-${i}`}>
                        <div className="gas-preview" style={{backgroundColor: item.color}}> </div> 
                        {item.desc} {item.plate ? "- " + item.plate : ""} : <b>{item.qty}</b>{item.unit}
                    </li>;
                })}
            </ul>

            { Object.keys(volByUnit).map(unit => <h2 key={`tooltip-total-${unit}`} className="heatmap-day-title">{volByUnit[unit].toFixed(2)}{unit}</h2>) }
        </div>;
    };

    vehicleSelected = e => {
        this.setState({
            filter: e.target.value
        }, this.loadData);
    };

    dateFromDay(year, day){
        let date = new Date(year, 0);
        return new Date(date.setDate(day));
    }

    formatDate(date, format="dddd DD MMMM HH:mm"){
        return moment(date).utc().format(format);
    }

    getFirstDayOffset = (year, day) => {
        let date = this.dateFromDay(year, day);
        let d = date.getDay();
        d--;
        if(d === -1)
            d = 6;
        return d;
    };

    drawFirstDaysOffset = nb => {
        return [...Array(nb)].map((h, i) => {
            return <div style={{display: 'inline'}} key={"sk-"+i}><div className="heatmap-week-day-container blank" > </div></div>
        });
    };

    mouseIn = () => {
        this.setState({
            showLegends: true
        });
    };

    mouseOut = () => {
        this.setState({
            showLegends: false
        });
    };

    setYear = year => {
        this.setState({
            filter: null,
            year: year
        }, this.loadData);
    };

    render(){
        let last_month = null;
        let print_month = false;

        let day_offset = this.getFirstDayOffset(this.state.year, 1);
        
        const { vehicleMax, full_quantity, vehicles, filter } = this.state;

        return <div className="heatmap-container" onMouseEnter={this.mouseIn} onMouseLeave={this.mouseOut}>
                <div className="heatmap-title-summary-container">
                    <h2 className=" ty-subtitle">
                        Ma consommation
                        <i className="icon icon-chevron-left heatmap-year-selection-button" onClick={() => { this.setYear(this.state.year - 1) }} />
                        { this.state.year }
                        <i className="icon icon-chevron-right heatmap-year-selection-button" onClick={() => { this.setYear(this.state.year + 1) }} />
                    </h2>

                    <div className="heatmap-summary-container">
                        <div>
                            <select className="form-control heatmap-vehicle-selection" onChange={ this.vehicleSelected }>
                                <option value="">vehicule ...</option>
                                {
                                    vehicles.map((v, i) => <option key={`v-${i}-${v.plate}`} value={v.plate} defaultChecked={ filter === v.plate }>
                                        {v.desc} {v.plate ? "- " + v.plate : ""}
                                    </option>)
                                }
                            </select>
                        </div>
                        <div>
                            <ul className="heatmap-summary">
                                <li><b>{ this.state.raw.length }</b> ravitaillements</li>
                                <li><b>{ vehicles.length }</b> v&eacute;hicules ravitaill&eacute;s</li>
                                { 
                                    Object.keys(full_quantity).map(unit => <li>
                                        <b>{ full_quantity[unit].toFixed(2) }</b> {UNIT_LABELS[unit]} d&eacute;livr&eacute;s
                                    </li>) 
                                }
                                {
                                    vehicleMax ?
                                        <li>
                                            <b>{ vehicleMax.desc } ({ vehicleMax.plate })</b><br/>
                                            a le plus consomm&eacute;,<br/>
                                            avec <b>{ vehicleMax.qty.toFixed(2) }</b> {UNIT_LABELS[vehicleMax.unit]} en <b>{ vehicleMax.nb }</b> fois
                                        </li>
                                        :
                                        null
                                }
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="heatmap-graph-container">
                    <div>
                        <div className={"heatmap-day-label " + (!this.state.showLegends ? "hide" : null)}>lun</div>
                        <div className={"heatmap-day-label " + (!this.state.showLegends ? "hide" : null)}>mar</div>
                        <div className={"heatmap-day-label " + (!this.state.showLegends ? "hide" : null)}>mer</div>
                        <div className={"heatmap-day-label " + (!this.state.showLegends ? "hide" : null)}>jeu</div>
                        <div className={"heatmap-day-label " + (!this.state.showLegends ? "hide" : null)}>ven</div>
                        <div className={"heatmap-day-label " + (!this.state.showLegends ? "hide" : null)}>sam</div>
                        { this.props.showSundays ? <div className={"heatmap-day-label " + (!this.state.showLegends ? "hide" : null)}>dim</div> : null }
                    </div>
                    {
                        [...Array(Math.ceil((this.nb_days + day_offset) / this.nb_days_week))].map((e, i) => {
                            print_month = false;

                            return <div className="heatmap-week-container" key={"s-"+i}>
                                {
                                    i === 0 && day_offset > 0 ?
                                        this.drawFirstDaysOffset(day_offset)
                                        :
                                        null
                                }

                                {
                                    [...Array(this.nb_days_week - (i === 0 ? day_offset : 0))].map((r, y) => {
                                        let percent = 5;
                                        let k = (i * this.nb_days_week) + y + 1 - (i > 0 ? day_offset : 0);

                                        if(k > this.nb_days - 1)
                                            return <div key={"sd-"+k} style={{display: 'inline'}}><div className="heatmap-week-day-container blank"> </div></div>

                                        let date = this.dateFromDay(this.state.year, k + 1);
                                        if(date.getMonth() !== last_month){
                                            last_month = date.getMonth();
                                            print_month = true;
                                        }

                                        let tooltip = <div>
                                            <h2 className="heatmap-day-title">{ this.formatDate(date, "DD/MM/YYYY") }</h2>
                                            Aucun
                                        </div>;

                                        if(this.state.data[k] && this.state.data[k].qty){
                                            tooltip = this.getToolTip(this.state.data[k]);
                                            percent = Math.ceil((this.state.data[k].qty * 100) / this.state.max);
                                        }

                                        return (this.props.showSundays || y < 6) ?
                                            <Tooltip key={"tltp-"+k}  html={tooltip} className="heatmap-day-tooltip"
                                                arrow={true}
                                                theme={'light'}
                                                animation={'shift'}
                                            >
                                                <div key={"d-"+k} className={"heatmap-week-day-container heatmap-op-" + percent}> </div>
                                            </Tooltip>
                                            : null
                                    })
                                }

                                {
                                    this.state.showLegends && print_month ?
                                        <div className="heatmap-month-label">{ months_label[last_month] }</div>
                                        : null
                                }
                            </div>;
                        })
                    }
                </div>
            </div>;
    }
}

Heatmap.defaultProps = {
    showSundays: true
};



// WEBPACK FOOTER //
// ./src/components/Analytics/Charts/Heatmap.js